import { getCurrentUser } from 'redux/selectors'

export const modalActions = {
  TOGGLE_LOGIN_MODAL: '@@modals/TOGGLE_LOGIN_MODAL',
  TOGGLE_REGISTER_MODAL: '@@modals/TOGGLE_REGISTER_MODAL',
  SET_REGISTER_FORM_TYPE: '@@modals/SET_REGISTER_FORM_TYPE',
  TOGGLE_EMAIL_VALIDATION_FORM: '@@modals/TOGGLE_EMAIL_VALIDATION_FORM',
  TOGGLE_PE_LEAD_MODAL: '@@modals/TOGGLE_PE_LEAD_MODAL',
}

export const toggleLoginModal =
  ({ show, force }) =>
  (dispatch, getState) => {
    if (getCurrentUser(getState()).id && show === true && !force) return
    return dispatch({ type: modalActions.TOGGLE_LOGIN_MODAL, show })
  }

export const toggleRegisterModal =
  (show, force = false) =>
  (dispatch, getState) => {
    if (!force && getCurrentUser(getState()).id && show === true) return
    return dispatch({ type: modalActions.TOGGLE_REGISTER_MODAL, show })
  }

export const toggleEmailValidationForm =
  ({ show }) =>
  (dispatch) => {
    return dispatch({ type: modalActions.TOGGLE_EMAIL_VALIDATION_FORM, show })
  }

export const togglePrivateEventLeadModal =
  (show = false) =>
  (dispatch) => {
    return dispatch({ type: modalActions.TOGGLE_PE_LEAD_MODAL, show })
  }

// handlers
const handleToggleAccountModal = (type) => (state, action) => {
  const otherType = type === 'register' ? 'login' : 'register'
  return state.setIn(['modals', type], action.show).setIn(['modals', otherType], false)
}

const handleShow = (type) => (state, action) => {
  return state.setIn(['modals', type], action.show)
}

const handleEmailValidationForm = (state, action) => {
  return state.setIn(['modals', 'waitingEmailValidation'], action.show)
}

export const modalCustomHandlers = {
  [modalActions.TOGGLE_LOGIN_MODAL]: handleToggleAccountModal('login'),
  [modalActions.TOGGLE_REGISTER_MODAL]: handleToggleAccountModal('register'),
  [modalActions.TOGGLE_EMAIL_VALIDATION_FORM]: handleEmailValidationForm,
  [modalActions.TOGGLE_PE_LEAD_MODAL]: handleShow('peLead'),
}
